module.exports = __webpack_public_path__ + "media/images/signal-strength-00-ed4978559ff722db66b6f9d7794fd2fe.svg";